import { required, shape } from '@totalsoft/pure-validations';

export const documentClauseValidator = shape({
  orderNo: required,
  clauseCode: required,
  clauseText: required,
  documentTypeId: required
});
